import _extends from '@babel/runtime-corejs3/helpers/extends';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _findInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import React__default, { forwardRef, useMemo, useRef, useState, useCallback, useEffect, cloneElement } from 'react';
import classNames from 'classnames';
import styles from './000c42ca305291142266f5779267d2cd1f0ecd948ac70fc4562b87a43c07d288.cfe-internal.js';
import ComboboxInput from './0aacf1e093033e1776ee12738ca179e7bc5c54eff56b2d563937bec52a74acd8.cfe-internal.js';
import ComboboxList from './8d557bbbb7a979b4bc93e36b4393cf9a97adfbfa477bf723f7b15af9f6aae7b4.cfe-internal.js';
import ComboboxOption from './999eee60ab3d159decd4ab7eb13c94fb74edc2081d19fd7acd691d8dda283cb3.cfe-internal.js';
import ComboboxHeader from './c9ca6f60675bc9ae1af4ca3bea96e7c37abbfc51a3f67793aa95f15debd57981.cfe-internal.js';
import ComboboxIcon from './c40011c63bedd0227e90b56df80eb63532172fb0b86ca158759e1da27cf1d7e7.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import { ComboboxContextProvider } from './b31cf09859637ddcb4d1a4a83c806ba39869aadedd96320b532d4c7939067785.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';
import useId from '../../hooks/useId/df6d0ff48c086d34ec4e3589a05e8dd99a305947cee007fa9f94a6dd07ae8d17.cfe-internal.js';
import filterChildren from '../../utils/filterChildren/8e05767937b448ec23ce6e76c596908579c0adc8168b146e50c6b9a36843b30d.cfe-internal.js';
import useControllableState from '../../hooks/useControllableState/fc7c2512fc1249f4837f2cb1f271d18191fa6aebd32c5f03023614c2b76711ef.cfe-internal.js';
import useClickOutside from '../../hooks/useClickOutside/093095b07737bf7e3954fcb01b077308dc339e5b14c18c3bec4dc276dceea639.cfe-internal.js';
import wrapEvent from '../../utils/wrapEvent/e6437ee06b490c01a1330c8f2f370768104fbf0b8f6557d196331cda5427061b.cfe-internal.js';
import useScreenReaderAnnouncement from '../../hooks/useScreenReaderAnnouncement/512f506263b51a28e4f5625270af84bc8ecd591bd1100039f845b39b162a4827.cfe-internal.js';
import { useDidUpdate } from '../../hooks/useDidUpdate/f8ce5c85f293b5c4ca8be6bc5ac9f246003ac61cc91ab03b8814ccaab638a21a.cfe-internal.js';

var _excluded = ["children", "className", "defaultValue", "disabled", "unstable_autoSelect", "isInvalid", "unstable_freeForm", "unstable_isLoading", "isOpen", "onIsOpenChange", "onChange", "value", "unstable_isOptionSelectedOnKeyboardHighlight", "isFilteringDisabled", "aria-label", "aria-labelledby"];
var getOptionLabel = function getOptionLabel(option) {
  var _option$props;
  return option === null || option === void 0 || (_option$props = option.props) === null || _option$props === void 0 ? void 0 : _option$props.label;
};
var getOptionValue = function getOptionValue(option) {
  var _option$props2;
  return option === null || option === void 0 || (_option$props2 = option.props) === null || _option$props2 === void 0 ? void 0 : _option$props2.value;
};
var doesOptionMatchFilter = function doesOptionMatchFilter(option, header, inputValue) {
  var _context, _context2;
  var label = getOptionLabel(option);

  // Filtering is turned off if the input value is empty or not a string, so the given option will be included in the filtered list, thus returns true
  if (typeof inputValue !== 'string' || !inputValue) {
    return true;
  }

  // Returns true if the given option's label or the given header includes the input value (the label and header must be strings in order to do the comparison)
  return typeof label === 'string' && _includesInstanceProperty(_context = label.toLowerCase()).call(_context, inputValue.toLowerCase()) || typeof header === 'string' && _includesInstanceProperty(_context2 = header.toLowerCase()).call(_context2, inputValue.toLowerCase());
};
var Combobox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _context3;
  var children = _ref.children,
    className = _ref.className,
    _ref$defaultValue = _ref.defaultValue,
    defaultSelectedOptionValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
    disabled = _ref.disabled,
    _ref$unstable_autoSel = _ref.unstable_autoSelect,
    unstable_autoSelect = _ref$unstable_autoSel === void 0 ? true : _ref$unstable_autoSel,
    _ref$isInvalid = _ref.isInvalid,
    isInvalid = _ref$isInvalid === void 0 ? false : _ref$isInvalid,
    _ref$unstable_freeFor = _ref.unstable_freeForm,
    unstable_freeForm = _ref$unstable_freeFor === void 0 ? false : _ref$unstable_freeFor,
    _ref$unstable_isLoadi = _ref.unstable_isLoading,
    unstable_isLoading = _ref$unstable_isLoadi === void 0 ? false : _ref$unstable_isLoadi,
    externalIsOpen = _ref.isOpen,
    onIsOpenChange = _ref.onIsOpenChange,
    onChange = _ref.onChange,
    externalSelectedOptionValue = _ref.value,
    unstable_isOptionSelectedOnKeyboardHighlight = _ref.unstable_isOptionSelectedOnKeyboardHighlight,
    _ref$isFilteringDisab = _ref.isFilteringDisabled,
    externalIsFilteringDisabled = _ref$isFilteringDisab === void 0 ? false : _ref$isFilteringDisab,
    ariaLabel = _ref['aria-label'],
    ariaLabelledby = _ref['aria-labelledby'],
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  var isOptionSelectedOnKeyboardHighlight = unstable_isOptionSelectedOnKeyboardHighlight;
  var isFilteringDisabled = isOptionSelectedOnKeyboardHighlight || externalIsFilteringDisabled;
  var comboboxInput = /*#__PURE__*/React__default.createElement(ComboboxInput, null);
  var comboboxList = /*#__PURE__*/React__default.createElement(ComboboxList, null);

  // Gets the <ComboboxInput> and <ComboboxList> components from the children
  _forEachInstanceProperty(_context3 = React__default.Children).call(_context3, children, function (child) {
    if ( /*#__PURE__*/React__default.isValidElement(child)) {
      if ((child === null || child === void 0 ? void 0 : child.type) === ComboboxInput) {
        comboboxInput = child;
      } else if ((child === null || child === void 0 ? void 0 : child.type) === ComboboxList) {
        comboboxList = child;
      }
    }
  });
  var listContainerId = useId(comboboxList.props.id);
  var noMatchesFoundContainerId = "".concat(listContainerId, "-no-matches-found");

  // Extracts all ComboboxOptions
  var _useMemo = useMemo(function () {
      var _comboboxList;
      return filterChildren((_comboboxList = comboboxList) === null || _comboboxList === void 0 || (_comboboxList = _comboboxList.props) === null || _comboboxList === void 0 ? void 0 : _comboboxList.children, [{
        matcher: function matcher(child) {
          return (child === null || child === void 0 ? void 0 : child.type) === ComboboxOption;
        }
      }]);
    }, [comboboxList]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    _useMemo2$ = _slicedToArray(_useMemo2[1], 1),
    allOptions = _useMemo2$[0];
  var _comboboxInput$props = comboboxInput.props,
    defaultInputValue = _comboboxInput$props.defaultValue,
    onInputChange = _comboboxInput$props.onChange,
    externalInputValue = _comboboxInput$props.value;
  var optionRefs = useRef({});
  var listRef = useRef(null);
  var inputRef = useRef(null);
  var iconRef = useRef(null);
  var _useControllableState = useControllableState(false, onIsOpenChange, externalIsOpen),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    isFlyoutOpen = _useControllableState2[0],
    setIsFlyoutOpen = _useControllableState2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isAriaExpanded = _useState2[0],
    setIsAriaExpanded = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isKeyboardUser = _useState4[0],
    setIsKeyboardUser = _useState4[1];

  // Highlighted index is only used when isOptionSelectedOnKeyboardHighlight is set to false
  var _useState5 = useState(-1),
    _useState6 = _slicedToArray(_useState5, 2),
    highlightedIndex = _useState6[0],
    setHighlightedIndex = _useState6[1];

  // This option value is the "computer readable" value. The option value is not used to set the input value.
  var _useControllableState3 = useControllableState(defaultSelectedOptionValue, onChange, externalSelectedOptionValue),
    _useControllableState4 = _slicedToArray(_useControllableState3, 2),
    selectedOptionValue = _useControllableState4[0],
    setSelectedOptionValue = _useControllableState4[1];
  var getLabelForValue = useCallback(function (value) {
    return getOptionLabel(_findInstanceProperty(allOptions).call(allOptions, function (option) {
      return getOptionValue(option) === value;
    }));
  }, [allOptions]);

  // The option label is the "human readable" value. The option label is used to set the input value.
  var _useState7 = useState(function () {
      return getLabelForValue(selectedOptionValue) || externalInputValue || defaultInputValue || '';
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedOptionLabel = _useState8[0],
    setSelectedOptionLabel = _useState8[1];
  var _useControllableState5 = useControllableState(selectedOptionLabel,
    // `e &&` prevents `ComboboxInput` from calling consumer-passed `onChange` for consumer-controlled `Combobox` value updates.
    function (_, e) {
      return e && (onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(e));
    }, externalInputValue),
    _useControllableState6 = _slicedToArray(_useControllableState5, 2),
    inputValue = _useControllableState6[0],
    setInputValue = _useControllableState6[1];

  // listen for updates from controlled value
  useEffect(function () {
    if (selectedOptionValue) {
      setInputValue(getLabelForValue(selectedOptionValue), null);
    }
  }, [selectedOptionValue, setInputValue, getLabelForValue]);

  // Selected index is only used when isOptionSelectedOnKeyboardHighlight is set to true
  var _useState9 = useState(function () {
      if (isOptionSelectedOnKeyboardHighlight) {
        for (var i = 0; i < allOptions.length; i += 1) {
          var option = allOptions[i];
          if (getOptionValue(option) === selectedOptionValue) {
            return i;
          }
        }
      }
      return -1;
    }),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedIndex = _useState10[0],
    setSelectedIndex = _useState10[1];
  var _useState11 = useState(''),
    _useState12 = _slicedToArray(_useState11, 2),
    activeDescendantId = _useState12[0],
    setActiveDescendantId = _useState12[1];
  useClickOutside([listRef, inputRef, iconRef], function () {
    return isFlyoutOpen && setIsFlyoutOpen(false);
  });

  // The number of options that match the filter for each header
  var headerCounts = {};

  // Gets the filtered options based on the current input value (only if isFilteringDisabled is false)
  var _useMemo3 = useMemo(function () {
      var _comboboxList2;
      var currentHeaderTitle;
      var handleSelect = function handleSelect(option) {
        var newOptionValue = getOptionValue(option);
        var newInputValue = getOptionLabel(option);
        setSelectedOptionValue(newOptionValue);
        setInputValue(newInputValue, {
          target: {
            value: newInputValue
          }
        });
      };
      return filterChildren((_comboboxList2 = comboboxList) === null || _comboboxList2 === void 0 || (_comboboxList2 = _comboboxList2.props) === null || _comboboxList2 === void 0 ? void 0 : _comboboxList2.children, [
      /*
       * For each header, adds a key value pair to the headerCounts object where the key is the header title and the value is 0.
       * The value will be updated in the matcher/modifier below this matcher/modifier.
       */
      {
        matcher: function matcher(child) {
          return (child === null || child === void 0 ? void 0 : child.type) === ComboboxHeader;
        },
        modifier: function modifier(child) {
          var _props;
          currentHeaderTitle = (_props = child.props) === null || _props === void 0 ? void 0 : _props.title;
          headerCounts[currentHeaderTitle] = 0;
          return child;
        }
      },
      /*
       * Increments the given option's header count and returns a cloned option component if the option is included in the filtered list.
       * Otherwise, returns null.
       */
      {
        matcher: function matcher(child) {
          return (child === null || child === void 0 ? void 0 : child.type) === ComboboxOption;
        },
        modifier: function modifier(child, index) {
          if (inputValue === selectedOptionLabel || isFilteringDisabled || doesOptionMatchFilter(child, currentHeaderTitle, inputValue)) {
            var _props$id, _context4;
            headerCounts[currentHeaderTitle] += 1;
            return /*#__PURE__*/cloneElement(child, {
              onSelect: function onSelect(e) {
                var _props2, _props2$onSelect;
                child === null || child === void 0 || (_props2 = child.props) === null || _props2 === void 0 || (_props2$onSelect = _props2.onSelect) === null || _props2$onSelect === void 0 || _props2$onSelect.call(_props2, e);

                // Prevents form submission
                if ((e === null || e === void 0 ? void 0 : e.key) === 'Enter') {
                  e.preventDefault();
                }
                if (!e.key) {
                  setIsFlyoutOpen(false);
                }
                handleSelect(child);
              },
              onMouseEnter: wrapEvent(child.props.onMouseEnter, function () {
                if (!isOptionSelectedOnKeyboardHighlight) {
                  setHighlightedIndex(index);
                }
                setIsKeyboardUser(false);
              }),
              onMouseLeave: wrapEvent(child.props.onMouseLeave, function () {
                if (!isOptionSelectedOnKeyboardHighlight) {
                  setHighlightedIndex(-1);
                }
                setIsKeyboardUser(false);
              }),
              isHighlightedOnHover: isOptionSelectedOnKeyboardHighlight,
              isHighlighted: isOptionSelectedOnKeyboardHighlight ? false : index === highlightedIndex,
              isSelected: isOptionSelectedOnKeyboardHighlight ? index === selectedIndex : selectedOptionValue === getOptionValue(child),
              id: (_props$id = child.props.id) !== null && _props$id !== void 0 ? _props$id : _concatInstanceProperty(_context4 = "".concat(listContainerId, "-option-")).call(_context4, index),
              ref: function ref(node) {
                optionRefs.current[Number(index)] = node;
              }
            });
          }
          return null;
        }
      }]);
    }, [comboboxList, headerCounts, highlightedIndex, inputValue, isFilteringDisabled, selectedOptionLabel, selectedOptionValue, setInputValue, setIsFlyoutOpen, setSelectedOptionValue, isOptionSelectedOnKeyboardHighlight, selectedIndex, listContainerId]),
    _useMemo4 = _slicedToArray(_useMemo3, 2),
    listChildrenFilteredOptions = _useMemo4[0],
    _useMemo4$ = _slicedToArray(_useMemo4[1], 2),
    filteredOptions = _useMemo4$[1];

  // Gets all filtered options, as well as headers that have at least one filtered option
  var _useMemo5 = useMemo(function () {
      return filterChildren(listChildrenFilteredOptions, [{
        matcher: function matcher(child) {
          return (child === null || child === void 0 ? void 0 : child.type) === ComboboxOption;
        }
      }, {
        matcher: function matcher(child) {
          return (child === null || child === void 0 ? void 0 : child.type) === ComboboxHeader;
        },
        modifier: function modifier(child) {
          var _props3;
          return headerCounts[(_props3 = child.props) === null || _props3 === void 0 ? void 0 : _props3.title] ? child : null;
        }
      }]);
    }, [headerCounts, listChildrenFilteredOptions]),
    _useMemo6 = _slicedToArray(_useMemo5, 1),
    listChildrenFilteredOptionsAndHeaders = _useMemo6[0];
  var keyboardHighlightOrSelectOption = function keyboardHighlightOrSelectOption(index, e) {
    setIsKeyboardUser(true);
    if (isOptionSelectedOnKeyboardHighlight) {
      var _filteredOptions$inde, _filteredOptions$inde2;
      setSelectedIndex(index);
      (_filteredOptions$inde = filteredOptions[index]) === null || _filteredOptions$inde === void 0 || (_filteredOptions$inde = _filteredOptions$inde.props) === null || _filteredOptions$inde === void 0 || (_filteredOptions$inde2 = _filteredOptions$inde.onSelect) === null || _filteredOptions$inde2 === void 0 || _filteredOptions$inde2.call(_filteredOptions$inde, e);
    } else {
      setHighlightedIndex(index);
    }
  };
  var handleFocus = function handleFocus() {
    if (!isFlyoutOpen) {
      setIsFlyoutOpen(true);
    }
  };
  var handleBlur = function handleBlur() {
    if (isFlyoutOpen) {
      setIsFlyoutOpen(false);
    }
    if (!inputValue) {
      if (selectedOptionValue !== '') {
        setSelectedOptionValue('');
      }
      return;
    }
    if (selectedOptionLabel !== inputValue) {
      // Updates the selected option value and selected index based on the input value
      if (unstable_autoSelect) {
        for (var i = 0; i < allOptions.length; i += 1) {
          var option = allOptions[i];
          if (getOptionLabel(option) === inputValue) {
            setSelectedOptionValue(getOptionValue(option));
            if (isOptionSelectedOnKeyboardHighlight) {
              setSelectedIndex(i);
            }
            return;
          }
        }
      }
      if (unstable_freeForm) {
        setSelectedOptionValue(null);
      } else {
        setInputValue(selectedOptionLabel, {
          target: {
            value: selectedOptionLabel
          }
        });
      }
    }
  };
  var handleInputChange = function handleInputChange(e) {
    e.persist();
    setIsAriaExpanded(false);
    setInputValue(e.target.value, e);
    if (!isOptionSelectedOnKeyboardHighlight) {
      setHighlightedIndex(-1);
    }
  };
  var handleKeyDown = function handleKeyDown(e) {
    var currentIndex = isOptionSelectedOnKeyboardHighlight ? selectedIndex : highlightedIndex;
    switch (e.key) {
      case 'Enter':
        if (isFlyoutOpen) {
          if (!isOptionSelectedOnKeyboardHighlight && filteredOptions.length > 0 && filteredOptions[highlightedIndex] !== undefined) {
            var _filteredOptions$high, _filteredOptions$high2;
            (_filteredOptions$high = filteredOptions[highlightedIndex]) === null || _filteredOptions$high === void 0 || (_filteredOptions$high = _filteredOptions$high.props) === null || _filteredOptions$high === void 0 || (_filteredOptions$high2 = _filteredOptions$high.onSelect) === null || _filteredOptions$high2 === void 0 || _filteredOptions$high2.call(_filteredOptions$high, e);
          }
        }
        setIsFlyoutOpen(false);
        break;
      case 'ArrowDown':
        e.preventDefault(); // Prevents cursor movement inside of input

        if (currentIndex + 1 < filteredOptions.length) {
          keyboardHighlightOrSelectOption(currentIndex + 1, e);
        } else if (currentIndex === -1 && filteredOptions.length > 0) {
          keyboardHighlightOrSelectOption(0, e);
        } else if (currentIndex >= filteredOptions.length && filteredOptions.length > 0) {
          keyboardHighlightOrSelectOption(filteredOptions.length - 1, e);
        }
        if (filteredOptions.length > 0) {
          setIsAriaExpanded(true);
        }
        setIsFlyoutOpen(true);
        break;
      case 'ArrowUp':
        e.preventDefault(); // Prevents cursor movement inside of input

        if (currentIndex - 1 >= 0) {
          keyboardHighlightOrSelectOption(currentIndex - 1, e);
        } else if (currentIndex >= filteredOptions.length || currentIndex === -1 && filteredOptions.length > 0) {
          keyboardHighlightOrSelectOption(filteredOptions.length - 1, e);
        }
        if (filteredOptions.length > 0) {
          setIsAriaExpanded(true);
        }
        setIsFlyoutOpen(true);
        break;
      case 'PageUp':
        e.preventDefault(); // Prevents page scroll

        if (filteredOptions.length > 0) {
          keyboardHighlightOrSelectOption(0, e);
          setIsAriaExpanded(true);
        }
        setIsFlyoutOpen(true);
        break;
      case 'PageDown':
        e.preventDefault(); // Prevents page scroll

        if (filteredOptions.length > 0) {
          keyboardHighlightOrSelectOption(filteredOptions.length - 1, e);
          setIsAriaExpanded(true);
        }
        setIsFlyoutOpen(true);
        break;
      case 'Escape':
        e.preventDefault();
        if (isFlyoutOpen) {
          e.stopPropagation(); // prevent event from closing modals or popovers
        }
        setIsFlyoutOpen(false);
        break;
      case 'ArrowLeft':
      case 'ArrowRight':
      case 'Home':
      case 'End':
        setIsAriaExpanded(false);
        break;
      default:
        return false;
    }
    return false;
  };

  // Scrolls to the highlighted option if the highlighted option is out of view
  useEffect(function () {
    var currentIndex = isOptionSelectedOnKeyboardHighlight ? selectedIndex : highlightedIndex;
    var optionRef = optionRefs.current[currentIndex];
    if (isKeyboardUser && isFlyoutOpen && optionRef && listRef !== null && listRef !== void 0 && listRef.current) {
      var _listRef$current, _listRef$current2;
      if (currentIndex === 0) {
        // Scrolls the first header into view if one exists
        listRef.current.scrollTop = 0;
      } else if (((_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollHeight) > ((_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 ? void 0 : _listRef$current2.clientHeight)) {
        var scrollBottom = listRef.current.clientHeight + listRef.current.scrollTop;
        var elementBottom = optionRef.offsetTop + optionRef.offsetHeight;
        if (elementBottom > scrollBottom) {
          listRef.current.scrollTop = elementBottom - listRef.current.clientHeight;
        } else if (optionRef.offsetTop < listRef.current.scrollTop) {
          listRef.current.scrollTop = optionRef.offsetTop;
        }
      }
    }
  }, [isKeyboardUser, highlightedIndex, selectedIndex, isOptionSelectedOnKeyboardHighlight, isFlyoutOpen]);

  // Updates the selected option label and selected option index based on the new selected option value
  useEffect(function () {
    if (isOptionSelectedOnKeyboardHighlight) {
      setSelectedIndex(-1);
    }
    if (selectedOptionValue === '') {
      setSelectedOptionLabel('');
      return;
    }
    for (var i = 0; i < allOptions.length; i += 1) {
      var option = allOptions[i];
      if (getOptionValue(option) === selectedOptionValue) {
        setSelectedOptionLabel(getOptionLabel(option));
        if (isOptionSelectedOnKeyboardHighlight) {
          setSelectedIndex(i);
          return;
        }
      }
    }
  }, [selectedOptionValue, allOptions, isOptionSelectedOnKeyboardHighlight]);
  useEffect(function () {
    if (!isFlyoutOpen) {
      setHighlightedIndex(-1);
      setIsAriaExpanded(false);
    }
  }, [isFlyoutOpen]);
  useEffect(function () {
    if (isAriaExpanded) {
      if (unstable_isLoading) {
        setActiveDescendantId("".concat(listContainerId, "-loading-spinner"));
      } else if (unstable_isOptionSelectedOnKeyboardHighlight) {
        var _filteredOptions$sele;
        setActiveDescendantId((_filteredOptions$sele = filteredOptions[selectedIndex]) === null || _filteredOptions$sele === void 0 ? void 0 : _filteredOptions$sele.props.id);
      } else if (filteredOptions.length === 0) {
        setActiveDescendantId(noMatchesFoundContainerId);
      } else {
        var _filteredOptions$high3;
        setActiveDescendantId((_filteredOptions$high3 = filteredOptions[highlightedIndex]) === null || _filteredOptions$high3 === void 0 ? void 0 : _filteredOptions$high3.props.id);
      }
    } else {
      setActiveDescendantId(undefined);
    }
  }, [isAriaExpanded, selectedIndex, highlightedIndex, unstable_isOptionSelectedOnKeyboardHighlight, filteredOptions, unstable_isLoading, listContainerId, noMatchesFoundContainerId]);
  var announceToScreenReader = useScreenReaderAnnouncement('assertive');
  useDidUpdate(function () {
    if (filteredOptions.length === 0) {
      announceToScreenReader(translate('noMatchesFound'));
    }
  }, [filteredOptions.length, announceToScreenReader]);
  return /*#__PURE__*/React__default.createElement(ComboboxContextProvider, {
    value: {
      isOpen: isFlyoutOpen,
      setIsOpen: setIsFlyoutOpen,
      isAriaExpanded: isAriaExpanded,
      setIsAriaExpanded: setIsAriaExpanded,
      inputValue: inputValue,
      handleFocus: handleFocus,
      handleBlur: handleBlur,
      handleInputChange: handleInputChange,
      handleKeyDown: handleKeyDown,
      inputRef: inputRef,
      iconRef: iconRef,
      listRef: listRef,
      isLoading: unstable_isLoading,
      disabled: disabled,
      isInvalid: isInvalid,
      listContainerId: listContainerId,
      activeDescendantId: activeDescendantId,
      isFilteringDisabled: isFilteringDisabled,
      isOptionSelectedOnKeyboardHighlight: unstable_isOptionSelectedOnKeyboardHighlight,
      highlightedIndex: highlightedIndex,
      setHighlightedIndex: setHighlightedIndex,
      selectedIndex: selectedIndex,
      setSelectedIndex: setSelectedIndex,
      numberOfOptions: filteredOptions.length,
      ariaLabel: ariaLabel,
      ariaLabelledby: ariaLabelledby
    }
  }, /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    className: classNames(styles.combobox, className),
    ref: ref
  }), comboboxInput, /*#__PURE__*/React__default.createElement(ComboboxIcon, null), /*#__PURE__*/React__default.cloneElement(comboboxList, {}, filteredOptions.length === 0 ? /*#__PURE__*/React__default.createElement("div", {
    className: styles.comboboxEmpty,
    id: noMatchesFoundContainerId
    // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
    ,
    role: "option" // `aria-selected` is omitted because this option is not selectable
  }, translate('noMatchesFound')) : listChildrenFilteredOptionsAndHeaders)));
});

export { Combobox as default };
